export default __webpack_public_path__ + "static/media/cashflow_icon4.b764e251.svg";